import Dashboard from 'views/Dashboard/Dashboard'
import { UserProfile } from 'views/UserProfile/UserProfile'
// import TableList from 'views/TableList/TableList'
//import {TerminologyTable} from 'views/TableList/TerminologyTable'
//import TerminologyTable2 from 'views/TableList/TerminologyTable2'
import SettingTabs from 'views/Settings/SettingTabs'
import { QBDemo } from 'elements/QueryBuilder/QBDemo'
// import { FamilyLogTable } from 'views/TableList/FamilyLogTable'
// import { NeedSolutionsTable } from 'views/TableList/NeedSolutionsTable'
// import Tree from 'views/Tree/Tree'
// import FamilyComplete from 'views/Tree/FamilyComplete'
// import MyTabs from 'views/Tree/Tabs'
// import TabsIntake from 'views/Tree/TabsIntake'
// import { MeetingSummaryTable } from 'views/Tree/MeetingSummaryTable'
//import { GoalsTable } from 'views/Tree/GoalsTable'
//import GoalsTableRT  from 'views/Tree/GoalsTableRT'
// import DigmaServices from 'views/Services/Services'
//import EditTable from 'views/Editdata/EditData'
//import FamilyStatus from 'views/FamilyStatus/FamilyStatus'
import FamilyReferralIndex from 'views/FamilyReferrals/FamilyReferralIndex'
//import { FamilyReferralForm } from 'views/FamilyReferrals/FamilyReferralForm'
//import FamilyReferralIndexNew from 'views/FamilyReferrals/FamilyReferralIndexNew'
//import FamilyReferralRoute from 'views/FamilyReferrals/FamilyReferralRoute'
import FamilyIntakeIndex from 'views/FamilyIntakes/FamilyIntakeIndex'
//import NameReferralForm from 'views/FamilyReferrals/FamilyReferralNew' 
// import { FamilyReferralForm } from 'views/FamilyReferrals/FamilyReferralForm' 
// import FamilyIntakeForm from 'views/FamilyReferrals/FamilyIntakeForm'
import FamilyProgramIndex from 'views/FamilyProgram/FamilyProgramIndex'
import FamilyPostProgramIndex from 'views/FamilyPost/FamilyPostProgramIndex'
import FamilyFormsIndex from 'views/Forms/FamilyFormsIndex'
import { DevBuild, LocalDir } from "../variables/Config"
import {DigmaMenuDashboard, DigmaMenuReferrals, DigmaMenuIntakes, DigmaMenuProgram, DigmaMenuAll, DigmaMenuForms, DigmaMenuQuery} from '../variables/DigmaDef'

// import FFSTable from 'views/FFSdata/FFSTable'
// import Typography from 'views/Typography/Typography';
// import Icons from 'views/Icons/Icons';
// import Maps from 'views/Maps/Maps';
import Notifications from 'views/Notifications/Notifications'
//import RestApi from 'views/RestApi/RestApi';
// import Upgrade from 'views/Upgrade/Upgrade';

const appRoutes = [
    { path: "/dashboard", name: DigmaMenuDashboard, icon: "pe-7s-graph", component: Dashboard },
    { path: "/FamilyReferral", name: DigmaMenuReferrals, icon: "pe-7s-note2", component: FamilyReferralIndex },
    { path: "/FamilyIntakeIndex", name: DigmaMenuIntakes, icon: "pe-7s-note2", component: FamilyIntakeIndex },
    { path: "/FamilyProgramIndex", name: DigmaMenuProgram, icon: "pe-7s-note2", component: FamilyProgramIndex },
    { path: "/FamilyPostProgramIndex", name: DigmaMenuAll, icon: "pe-7s-note2", component: FamilyPostProgramIndex },
    { path: "/FamilyFormsIndex", name: DigmaMenuForms, icon: "pe-7s-drawer", component: FamilyFormsIndex },
    { path: "/QBDemo", name: DigmaMenuQuery, icon: "pe-7s-drawer", component: QBDemo },
    { nosidebar: !DevBuild, path: "/SettingTabs", name: "הגדרות אפליקציה", icon: "pe-7s-drawer", component: SettingTabs },
//    { path: "/TabsIntake", name: "הדגמה אינטייק", icon: "pe-7s-note2", component: TabsIntake },
//    { path: "/MyTabs", name: "הדגמה בתוכנית", icon: "pe-7s-note2", component: MyTabs },
//    { path: "/FamilyReferralNew", name: "NEW-הפניות", icon: "pe-7s-note2", component: FamilyReferralIndexNew },

 //   { nosidebar: true, path: "/FamilyIntakeForm", name: "אינטייק חדש", icon: "pe-7s-note2", component: FamilyIntakeForm },
 //   { path: "/FamilyComplete", name: "מסיימות", icon: "pe-7s-note2", component: FamilyComplete },
 //   { path: "/tree", name: "2מסיימות", icon: "pe-7s-note2", component: Tree },GoalsTable
 //   { nosidebar: true, path: "/GoalsTableRT", name: "2עמידה ביעדים", icon: "pe-7s-note2", component: GoalsTableRT },
 //   { nosidebar: true, path: "/GoalsTable", name: "עמידה ביעדים", icon: "pe-7s-note2", component: GoalsTable },
 //   { nosidebar: true, path: "/DigmaServices", name: "רשימת שירותים", icon: "pe-7s-note2", component: DigmaServices },
 //   { nosidebar: true, path: "/table", name: "הגדרות", icon: "pe-7s-note2", component: TableList },
//    { nosidebar: !DevBuild, path: "/TerminologyTable", name: "הגדרות מונחים", icon: "pe-7s-note2", component: TerminologyTable },
//    { nosidebar: !DevBuild, path: "/TerminologyTable2", name: "2הגדרות מונחים", icon: "pe-7s-note2", component: TerminologyTable2 },
 //   { nosidebar: true, path: "/FamilyLogTable", name: "ארועי משפחה", icon: "pe-7s-note2", component: FamilyLogTable },
 //   { nosidebar: true, path: "/NeedSolutionsTable", name: "צרכים ומענים", icon: "pe-7s-note2", component: NeedSolutionsTable },
    
    { path: "/user", name: "נתוני משתמש", icon: "pe-7s-user", component: UserProfile },
//    { path: "/RestApi", name: "RestApi", icon: "pe-7s-note2", component: RestApi },
//   { nosidebar: true, path: "/Editdata", name: "טבלה לעריכה", icon: "pe-7s-note2", component: EditTable },
 //   { nosidebar: true, path: "/FamilyStatus", name: "סטטוס משפחה", icon: "pe-7s-note2", component: FamilyStatus },
 //   { nosidebar: !DevBuild, path: "/FFSdata", name: "כלים שימושיים", icon: "pe-7s-note2", component: FFSTable },
 //   { nosidebar: true, path: "/FamilyReferralForm", name: "הפניה חדשה", icon: "pe-7s-note2", component: FamilyReferralForm }, 
//    { nosidebar: true, path: "/NameReferralForm", name: "הפניה חדשה", icon: "pe-7s-note2", component: NameReferralForm }, 
//    { nosidebar: true, path: "/MeetingSummaryTable", name: "סיכומי מפגש", icon: "pe-7s-note2", component: MeetingSummaryTable },

//    { path: "/typography", name: "טיפוגרפיה", icon: "pe-7s-news-paper", component: Typography },
//    { path: "/icons", name: "צלמיות", icon: "pe-7s-science", component: Icons },
//    { path: "/maps", name: "מפות", icon: "pe-7s-map-marker", component: Maps },
    { nosidebar: true, path: "/notifications", name: "התראות", icon: "pe-7s-bell", component: Notifications },
//    { upgrade: true, path: "/upgrade", name: "Upgrade to PRO", icon: "pe-7s-rocket", component: Upgrade },
    { redirect: true, path:"/", to:"/dashboard", name: "Dashboard" }
]

export const myRoutes = [
//   { path: LocalDir + "/#/FamilyReferralForm", name: "הפניה חדשה", icon: "pe-7s-note2", component: FamilyReferralForm },
//   { path: LocalDir + "/#/NameReferralForm", name: "הפניה חדשה", icon: "pe-7s-note2", component: NameReferralForm },
//    { path: LocalDir + "/#/FamilyReferral", name: "הפניות", icon: "pe-7s-note2", component: FamilyReferralIndex },
//    { path: LocalDir + "/#/MyTabs", name: "טאבים באינטייק", icon: "pe-7s-note2", component: MyTabs },
//    { path: LocalDir + "/#/FamilyIntakeForm", name: "אינטייק חדש", icon: "pe-7s-note2", component: FamilyIntakeForm },
//    { path: LocalDir + "/#/MeetingSummaryTable", name: "סיכומי מפגש", icon: "pe-7s-note2", component: MeetingSummaryTable },
    { divider: true },
//    { path: LocalDir + "/#/GoalsTable", name: "עמידה ביעדים", icon: "pe-7s-note2", component: GoalsTable },
    { path: LocalDir + "/#/notifications", name: "התראות", icon: "pe-7s-bell", component: Notifications },
//    { path: LocalDir + "/#/Editdata", name: "טבלה לעריכה", icon: "pe-7s-note2", component: EditTable },


]

export default appRoutes;
